import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";

import productStyle from "assets/jss/material-kit-react/views/landingPageSections/productStyle.jsx";
import image1 from "assets/img/fssc22000.png";
// import image101 from "assets/img/02dec1918.png";
// import image102 from "assets/img/14122018-2.png";
// import imageIso from "assets/img/27000family.png";

class ProductSection extends React.Component {
  state = {
    open: false,
    expanded: null,
  };

  handleClick = () => {
    this.setState(state => ({ open: !state.open }));
  };

  handleChange = panel => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false,
    });
  };

  render() {
    // const { expanded } = this.state;
    const { classes } = this.props;
    return (
      <div className={classes.section}>
        <div className={classes.container}>
          <GridContainer justify="center" style={{ textAlign: "left", color: "black" }}>
            <GridItem xs={12} sm={12} md={10}>
              <Card>
                <CardBody>
                  <span style={{ marginBottom: 0 }}>19 January 2019, 08.00 PM</span>
                  <h2 style={{ color: "#4BB64B", marginTop: 0 }}><b>Pentingnya Manajemen Keamanan Pangan FSSC 22000</b></h2>
                  <span style={{ fontSize: 18 }}>
                    <br />
                    <center>
                      <img src={image1} alt="Images" style={{ width: 624, height: 404, marginRight: 25 }} />
                    </center> <br /><br />
                    <p style={{ fontSize: 18 }}>
                      Mungkin kita akan menganggap biasa jika kita mengalami mual, pusing, atau diare sesudah mengkonsumsi produk makanan atau minuman tertentu. Namun demikian, gangguan kesehatan yang berasal dari produk yang kita konsumsi dapat mengganggu produktivitas kerja bahkan dalam taraf tertentu bisa menjadi kasus serius yang memerlukan penanganan medis yang jika terlambat bukan tidak mungkin mengakibatkan kematian.
                    </p>
                    <p style={{ fontSize: 18 }}>
                      Setiap tahunnya terjadi ribuan kasus kematian yang diakibatkan dari patogen maupun zat berbahaya dalam makanan dan minuman yang dikonsumsi manusia. Meskipun ancaman bahaya dari konsumsi pangan yang tidak aman adalah bersifat nyata, namun hal itu dapat dicegah dengan penerapan metode manajemen kemanan pangan yang bersifat menyeluruh dan sistematis. Oleh karena itu, produsen maupun rantai distribusi produk makanan dan minuman perlu menerapkan sebuah standar yang telah diakui secara internasional.
                    </p>
                    <p style={{ fontSize: 18 }}>
                      FSSC 22000 adalah sistem manajemen keamanan pangan yang paling lengkap. Dikatakan yang paling lengkap karena FSSC 22000 merupakan kombinasi dari standar ISO 22000 dengan sector khusus persyaratan kebutuhan kebersihan pangan PAS 220 dan HACCP. FSSC telah mendapat pengakuan penuh oleh Global Food Safety Initiative (GFSI).
                    </p>
                    <p style={{ fontSize: 18 }}>
                      Cakupan FSSC 22000 dimaksudkan untuk audit, sertifikasi, dan pendaftaran keamanan pangan. Kategori produk yang dicakup oleh FSSC 22000 adalah sebagai berikut:
                    </p>
                    <ol>
                      <li>Produk peternakan seperti daging, susu, telur dan madu.</li>
                      <li>Pembuatan produk makanan:</li>
                      <ol type="a" >
                        <li>Produksi produk hewani seperti daging, unggas, telur, susu dan produk ikan / makanan laut.</li>
                        <li>Produksi produk tanaman seperti buah-buahan, jus segar, sayuran, biji-bijian, dan kacang-kacangan.</li>
                        <li>Pemrosesan produk produk campuran (hewani&tumbuhan) seperti pizza, lasagna, sandwich, pangsit, atau makanan siap saji lainnya.</li>
                        <li>Produksi produk dengan masa kadaluarsa yang panjang pada suhu ruang seperti produk pangan dalam kaleng, biskuit, makanan ringan, minyak, air minum, minuman, pasta, tepung, gula, garam.</li>
                      </ol>
                      <li>Pembuatan bahan pangan yang mengadung bahan kimia seperti  aditif makanan dan pakan, vitamin, mineral, biokultur, perasa, enzim dan alat bantu pengolahan tetapi tidak termasuk pestisida, obat-obatan, pupuk dan agen pembersih</li>
                      <li>Pembuatan kemasan makanan dan bahan kemasan</li>
                      <li>Pembuatan makanan dan pakan untuk hewan seperti produk makanan untuk anjing dan kucing, pakan ternak, pakan ikan.</li>
                      <li>Layanan aktivitas penyimpanan dan transportasi melintasi rantai pasokan makanan.</li>
                      <li>Katering mencakup proses persiapan, penyimpanan dan, bila perlu, pengiriman makanan untuk dikonsumsi, di tempat persiapan atau tempat yang ditunjuk.</li>
                      <li>Penyediaan produk makanan jadi kepada pelanggan seperti outlet ritel, toko, pedagang grosir.</li>
                    </ol>
                    <p style={{ fontSize: 18 }}>
                      Sistem manajemen keamanan pangan FSSC 22000 memberikan kerangka kerja yang efektif agar perusahaan/organisasi anda dapat memiliki tanggung jawab atas keamanan pangan. Dengan memiliki sistem manajemen keamanan pangan FSSC 22000, perusahaan Anda akan mendapatkan pengakuan atas komitmen berkelanjutan yang memenuhi persyaratan keamanan pangan bagi konsumen, dan meningkatkan kepercayaan konsumen terhadap merek perusahaan Anda.
                    </p>
                    <p style={{ fontSize: 18 }}>
                      Begitu besar manfaat dan keuntungan yang akan peroleh jika mengikuti standar internasional sistem keamanan pangan ini. Dan di pihak konsumen juga tidak perlu merasa kuatir karena perusahaan yang memiliki sertifikat FSSC 22000 menjamin bahwa produk yang dihasilkan aman untuk dikonsumsi.
                    </p>
                    <br />
                  </span>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      </div >
    );
  }
}

export default withStyles(productStyle)(ProductSection);



// WEBPACK FOOTER //
// ./src/views/News/Sections/ProductSection.7.jsx